import React, { Component } from "react";
import {
  IntroBox,
  IntroBg,
  ImageBg,
  IntroContent,
  IntroH1,
  IntroP,
  IBWrap,
  ArrowForward,
  ArrowRight,
} from "./atoms";
import { Button } from "../Button";
import Image from "../../images/intro.jpg";
import { animateScroll as scroll } from "react-scroll";

class Intro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false,
    };
    this.toggleHover = this.toggleHover.bind(this);
  }
  toggleHover() {
    this.setState({ hover: !this.state.hover });
  }
  render() {
    return (
      <>
        <IntroBox>
          <IntroBg>
            <ImageBg src={Image} type="image/jpg" />
          </IntroBg>
          <IntroContent>
            <IntroH1>Evan Campion</IntroH1>
            <IntroP>Full-Stack Web Development</IntroP>
            <IBWrap>
              <Button
                to="about"
                onMouseEnter={this.toggleHover}
                onMouseLeave={this.toggleHover}
                primary="true"
                dark="true"
                smooth={true}
                duration={500}
                spy={true}
                offset={-80}
              >
                Check it out{" "}
                {this.state.hover ? <ArrowForward /> : <ArrowRight />}
              </Button>
            </IBWrap>
          </IntroContent>
        </IntroBox>
      </>
    );
  }
}

export default Intro;
